'use strict';

(function () {
  'use strict';

  angular.module('msWidgets').directive('msWidgetToolsActionItem', msWidgetToolsActionItem);

  msWidgetToolsActionItem.$inject = [];

  function msWidgetToolsActionItem() {
    var directive = {
      bindToController: true,
      controller: ['$scope', 'actionPlanSvc', 'eventTrackingSvc', Controller],
      controllerAs: 'vm',
      template: '<ms-action-item save-action="vm.addActionItem()" undo-action="vm.undoAddItem()" existing-list="vm.plan" action-item-copy="vm.aiCopy" previously-added="vm.previouslyAdded"></ms-action-item>',
      restrict: 'E'
    };
    return directive;
  }

  function Controller($scope, actionPlanSvc, eventTrackingSvc) {
    var vm = this;
    vm.addActionItem = addActionItem;
    vm.undoAddItem = removeActionItem;
    activate();

    function activate() {
      actionPlanSvc.getActionItem($scope.widget.properties.actionItemId).then(function (ai) {
        vm.actionItem = ai;
        vm.aiCopy = {
          leader: 'sleep.plan.youJustLearned',
          title: ai.title,
          addTo: 'sleep.plan.name',
          description: ai.description,
          question: 'sleep.plan.areYouInterested'
        };
      });

      getPlan().then(function (resp) {
        return vm.previouslyAdded = _.some(resp, ['id', parseInt($scope.widget.properties.actionItemId)]);
      });
    }

    function addActionItem() {
      eventTrackingSvc.fireEvent('sleepTool', 'actionItemAdded', vm.actionItem.title);
      return actionPlanSvc.addToPlan(vm.actionItem.id).then(function () {
        getPlan();
      });
    }

    function removeActionItem() {
      return actionPlanSvc.removeFromPlan(vm.actionItem.id).then(function () {
        getPlan();
      });
    }

    function getPlan() {
      return actionPlanSvc.getMyPlan().then(function (plan) {
        vm.plan = _.map(plan, 'title');
        return plan;
      });
    }
  }
})();